const devMode = process.env.REACT_APP_DEV_MODE === "true";

const file = devMode ? "/fcm-sw-dev.js" : "/fcm-sw-prod.js";

export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const regList = await getAllRegistrations();
      for (const reg of regList) {
        if (reg.active && !reg.active.scriptURL.endsWith(file)) {
          console.log(
            "[SW]: Unregistering old service worker:",
            reg.active.scriptURL
          );
          await reg.unregister();
        }
      }
      const registration = await navigator.serviceWorker.register(file, {
        scope: "/",
      });
      console.log("[SW]: Registered with scope:", registration.scope);
      return registration.scope;
    } catch (error) {
      console.error("[SW]: Registration failed:", error);
      return null;
    }
  }
};

export const getFCMRegistration = () => {
  if ("serviceWorker" in navigator) {
    try {
      return navigator.serviceWorker.getRegistration(file);
    } catch (error) {
      return undefined;
    }
  }

  return undefined;
};

export const getAllRegistrations = () => {
  if ("serviceWorker" in navigator) {
    try {
      return navigator.serviceWorker.getRegistrations();
    } catch (error) {
      return [];
    }
  }

  return [];
};
